/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 关联三方用户
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class RelationThirdUserParams {
  constructor(
    public channel: string,
    public mobile: string,
    public openId: string,
    public unionId?: string
  ) {}
}

export default async function (
  params: RelationThirdUserParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: string;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "put",
    url: `/member/member/third-user/relation`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
